// Pathify
import { make } from 'vuex-pathify'
import { importChunk } from '@/util/helpers'

const _ = require('lodash')

const endpoint = 'https://7srj7zor43.execute-api.us-east-2.amazonaws.com'
const setIsBusy = 'setIsBusy'

const state = {
  displayAsSingular: 'Category',
  displayAsPlural: 'Categories',
  categories: {
    data: [],
    originalData: [],
    toImport: [],
    isBusy: false,
    isFirst: false,
    isLast: false,
    selected: [],
    selectedItem: { id: '', description: '' },
    empty: {
      id: null,
      vendor_id: null,
      client_id: null,
      description: null,
      note: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      zip: '',
      country: '',
      email: '',
      fax: '',
      mobile: '',
      phone: '',
      tax_id: '',
      updated: false,
      update_program: null,
      update_user_id: null,
    },
    headers: {
      headerId: {
        text: 'ID',
        align: 'start',
        value: 'id',
        sortable: true,
        filterable: true,
        groupable: false,
        width: '1%',
        class: 'primary--text font-weight-bold',
      },
      headerDescription: {
        text: 'Description',
        align: 'start',
        value: 'description',
        sortable: true,
        filterable: true,
        groupable: false,
        width: '1%',
        class: 'primary--text font-weight-bold',
      },
    },
    tabbedColumns: {
      id_header: 'Category ID',
      description_header: 'Category Description',
    },
  },
}

const mutations = {
  ...make.mutations(state),

  setIsBusy: (state, isBusy) => {
    state.categories.isBusy = isBusy
  },

  setEmpty: () => {
    state.categories.selected = []
    state.categories.selectedItem = { id: '', description: '' }
    state.categories.data = []
  },

  setSelected: (state, payload) => {
    state.categories.selected = []
    state.categories.selectedItem = { ...payload }
  },

  setIsFirst: (state) => {
    let isFirst = false
    const selectedObject = state.categories.selectedItem

    if (selectedObject && {}.hasOwnProperty.call(selectedObject, 'id')) {
      const selectedId = selectedObject.id
      const thisData = state.categories.data

      if (thisData && thisData.length > 0) {
        if ({}.hasOwnProperty.call(thisData[0], 'id')) {
          const firstId = thisData[0].id

          if (firstId === selectedId) {
            isFirst = true
          }
        }
      } else {
        isFirst = true
      }
    } else {
      isFirst = true
    }

    state.categories.isFirst = isFirst
  },

  setIsLast: (state) => {
    let isLast = false
    const selectedObject = state.categories.selectedItem

    if (selectedObject && {}.hasOwnProperty.call(selectedObject, 'id')) {
      const selectedId = selectedObject.id
      const thisData = state.categories.data

      if (thisData && thisData.length > 0) {
        if ({}.hasOwnProperty.call(thisData[thisData.length - 1], 'id')) {
          const lastId = thisData[thisData.length - 1].id

          if (lastId === selectedId) {
            isLast = true
          }
        }
      } else {
        isLast = true
      }
    } else {
      isLast = true
    }

    state.categories.isLast = isLast
  },

  push2Data: (state, dataFromDB) => {
    state.categories.data = []
    state.categories.originalData = []

    // Get a copy of the original data, not a pointer to it
    for (const currentData of dataFromDB) {
      state.categories.data.push({ ...currentData })
      state.categories.originalData.push({ ...currentData })
    }

    state.categories.selected = []

    state.categories.isBusy = false
  },

  push2Import: (state, data2Import) => {
    state.categories.toImport = []
    state.categories.toImport = data2Import
    state.categories.isBusy = false
  },

  importCompleted: (state) => {},
}

const actions = {
  ...make.actions(state),

  init: async () => {
    //
  },

  setEmpty: ({ commit, dispatch }) => {
    commit('setEmpty')
    dispatch('part/setEmpty', null, { root: true })
    commit('setIsFirst')
    commit('setIsLast')
  },

  setSelected: ({ commit, dispatch }, payload) => {
    if (payload) {
      commit('setSelected', payload)
      dispatch('part/retrieve', payload, { root: true })
    } else {
      state.categories.selectedItem = { id: '', description: '' }
      dispatch('part/setEmpty', null, { root: true })
    }
    commit('setIsFirst')
    commit('setIsLast')
  },

  previous: ({ dispatch }) => {
    let previousObject = null
    const selectedId = state.categories.selectedItem.id

    for (const existingObject of state.categories.data) {
      if (existingObject.id === selectedId) {
        break
      }

      previousObject = { ...existingObject }
    }

    if (previousObject) {
      dispatch('setSelected', previousObject)
      // dispatch setSelected last division last assembly
    }
  },

  next: ({ dispatch }) => {
    let nextObject = null
    const selectedId = state.categories.selectedItem.id

    for (let thisIndex = state.categories.data.length - 1; thisIndex >= 0; thisIndex--) {
      const existingObject = state.categories.data[thisIndex]

      if (existingObject.id === selectedId) {
        break
      }

      nextObject = { ...existingObject }
    }

    if (nextObject) {
      dispatch('setSelected', nextObject)
    }
  },

  retrieveAll: ({ commit, dispatch, rootState }) => {
    if (rootState.customer.customers.selectedItem.client_id.length > 0) {
      const thisAction = 'retrieveAllCategories'
      commit(setIsBusy, true)

      const actionEndPoint = `${endpoint}/${rootState.app.build_environment}/${thisAction}`
      const url = `${actionEndPoint}/${rootState.customer.customers.selectedItem.client_id}`

      const options = {
        method: 'get',
      }

      fetch(url, options)
        .then(response => {
          const statusMessage = `${response.status}: "${response.statusText}"`

          if (!response.ok) {
            throw Error(statusMessage)
          }

          return response.json()
        })
        .then(jsonResponse => {
          commit('push2Data', jsonResponse.data)
        })
        .then(() => {
          state.categories.setLast = false

          if (state.categories.data.length > 0) {
            const selectedParent = rootState.customer.customers.selectedItem
            const selectedItem = state.categories.selectedItem

            // If we have a selected parent object and selectedItem is empty, select the first data item
            if (selectedParent && {}.hasOwnProperty.call(selectedParent, 'id') && selectedItem && {}.hasOwnProperty.call(selectedItem, 'id')) {
              if (selectedParent.id.trim().length > 0 && selectedItem.id.trim().length <= 0) {
                dispatch('setSelected', state.categories.data[0])
              }
            }
          }
        })
        .catch(error => {
          console.error(`${thisAction} failed with url: ${url}`)
          commit(setIsBusy, false)
          dispatch('error/setError', { name: thisAction, details: error }, { root: true })
        })
    }
  },

  update: ({ commit, dispatch, rootState }, payload) => {
    const thisAction = 'updateCategories'
    commit(setIsBusy, true)

    payload.vendor_id = payload.id

    const actionEndPoint = `${endpoint}/${rootState.app.build_environment}/${thisAction}`
    const url = `${actionEndPoint}/${payload.client_id}`

    const options = {
      method: 'post',
      body: JSON.stringify(payload),
    }

    let toastColor = 'success'
    let toastMessage = 'updated successfully'

    fetch(url, options)
      .then(response => {
        const statusMessage = `${response.status}: "${response.statusText}"`

        if (!response.ok) {
          throw Error(statusMessage)
        }

        return response.json()
      })
      .then(jsonResponse => {
        if (_.isEmpty(jsonResponse.error)) {
          // Update selected
          if (state.categories.selectedItem && {}.hasOwnProperty.call(state.categories.selectedItem, 'id')) {
            if (payload.vendor_id === state.categories.selectedItem.id) {
              dispatch('setSelected', payload)
            }
          }

          dispatch('retrieveAll')
        } else {
          toastColor = 'danger'
          toastMessage = 'was not updated successfully'
          console.error(`${thisAction} failed with url: ${url}`)
          commit(setIsBusy, false)
          dispatch('error/setError', { name: thisAction, details: jsonResponse.error }, { root: true })
        }
      })
      .then(() => {
        console.info(`${state.displayAsSingular} Updated - '${payload.description}' ${toastMessage}, variant: ${toastColor}`)
        /*
        dispatch('user/showToast',
          {
            title: `${state.displayAsSingular} Updated`,
            messages: [`'${payload.description}' ${toastMessage}`],
            variant: toastColor,
          },
          { root: true },
        )
         */
      })
      .catch(error => {
        console.error(`${thisAction} failed with url: ${url}`)
        commit(setIsBusy, false)
        dispatch('error/setError', { name: thisAction, details: error }, { root: true })
      })
  },

  delete: ({ commit, dispatch, rootState }) => {
    if (state.categories.selected.length > 0) {
      const thisAction = 'deleteCategories'
      commit(setIsBusy, true)

      const actionEndPoint = `${endpoint}/${rootState.app.build_environment}/${thisAction}`
      const url = `${actionEndPoint}/${state.categories.selected[0].client_id}`

      const options = {
        method: 'post',
        body: JSON.stringify(state.categories.selected),
      }

      let toastColor = 'success'
      let toastPrefix = ''
      let toastMessage = 'successfully removed'
      if (state.categories.selected.length > 1) {
        toastPrefix = `${state.categories.selected.length} ${state.displayAsPlural} were`
      } else {
        toastPrefix = `'${state.categories.selected[0].description}'`
      }

      fetch(url, options)
        .then(response => {
          const statusMessage = `${response.status}: "${response.statusText}"`

          if (!response.ok) {
            throw Error(statusMessage)
          }

          return response.json()
        })
        .then(jsonResponse => {
          if (_.isEmpty(jsonResponse.error)) {
            // Remove deleted from selected
            if (state.categories.selectedItem && {}.hasOwnProperty.call(state.categories.selectedItem, 'id')) {
              for (const currentData of state.categories.selected) {
                if (currentData.vendor_id === state.categories.selectedItem.id) {
                  dispatch('setSelected', state.categories.data[0])
                  break
                }
              }
            }

            dispatch('retrieveAll')
          } else {
            toastColor = 'danger'
            toastMessage = 'was not deleted successfully'
            console.error(`${thisAction} failed with url: ${url}`)
            commit(setIsBusy, false)
            dispatch('error/setError', { name: thisAction, details: jsonResponse.error }, { root: true })
          }
        })
        .then(() => {
          console.info(`${state.displayAsSingular} Deleted - ${toastPrefix} ${toastMessage}, variant: ${toastColor}`)
          /*
          dispatch('user/showToast',
            {
              title: `${state.displayAsSingular} Deleted`,
              messages: [`'${payload.description}' ${toastMessage}`],
              variant: toastColor,
            },
            { root: true },
          )
           */
        })
        .catch(error => {
          console.error(`${thisAction} failed with url: ${url}`)
          commit(setIsBusy, false)
          dispatch('error/setError', { name: thisAction, details: error }, { root: true })
        })
    }
  },

  importAll: ({ commit, dispatch, rootState, state }, payload) => {
    const thisAction = 'updateCategories'

    if (rootState.customer.customers.selectedItem.client_id.length > 0 && payload.length > 0) {
      commit(setIsBusy, true)

      const actionEndPoint = `${endpoint}/${rootState.app.build_environment}/${thisAction}`
      const url = `${actionEndPoint}/${rootState.customer.customers.selectedItem.client_id}`

      const emptyItem = { ...state.categories.empty }
      dispatch('user/setStateAsUpdated', emptyItem, { root: true })

      // Get an even number of records in each chunk
      const numberOfChunks = Math.ceil(payload.length / 100)
      const maxSize = Math.ceil(payload.length / numberOfChunks)
      let chunkSize = 0
      const chunks2Import = []
      let totalAttempted = 0
      let items2Import = []
      let item2Import = {}

      for (const currentItem of payload) {
        // Ensure we have all required data and the proper selected client
        item2Import = { ...emptyItem }

        item2Import.id = currentItem.id
        item2Import.vendor_id = currentItem.id
        item2Import.description = currentItem.description

        items2Import.push(item2Import)
        ++chunkSize

        if (chunkSize >= maxSize) {
          chunks2Import.push(importChunk(state.displayAsPlural, url, [...items2Import]))

          totalAttempted += chunkSize
          chunkSize = 0
          items2Import = []
        }
      }

      if (chunkSize > 0) {
        chunks2Import.push(importChunk(state.displayAsPlural, url, [...items2Import]))
        totalAttempted += chunkSize
      }

      let toastColor = 'success'
      let toastMessage = 'imported successfully'

      if (chunks2Import.length > 0) {
        // Once all promises are resolved we have a successful import, or display rejected error
        Promise.all(chunks2Import)
          .then(responses => {
            dispatch('importData/setImportCount', { sheetName: state.displayAsPlural, importCount: totalAttempted }, { root: true })
            dispatch('importData/setSelectedIsComplete', state.displayAsPlural, { root: true })
            commit('importCompleted')
            dispatch('retrieveAll')

            for (const thisResponse of responses) {
              if (_.isEmpty(thisResponse.error)) {
                console.info(`${thisResponse.details} { ${toastMessage}, variant: ${toastColor} }`)
              } else {
                toastColor = 'danger'
                toastMessage = 'were not imported successfully'
                console.error(`${thisAction} failed with url: ${url}`)
                commit(setIsBusy, false)
                dispatch('importData/setIsBusy', false, { root: true })
                dispatch('error/setError', thisResponse, { root: true })
                break
              }
            }
          })
          .catch(error => {
            console.error(`${thisAction} failed for ${state.displayAsSingular}`)
            commit(setIsBusy, false)
            dispatch('importData/setIsBusy', false, { root: true })
            dispatch('error/setError', { name: thisAction, details: error }, { root: true })
          })
      } else {
        console.error(`${thisAction} failed for ${state.displayAsSingular} due to empty chunks`)
        commit(setIsBusy, false)
        dispatch('importData/setIsBusy', false, { root: true })

        toastColor = 'warning'

        dispatch('user/showToast',
          {
            title: `Import ${state.displayAsPlural}`,
            messages: [`No ${state.displayAsPlural.toLowerCase()} were imported`],
            variant: toastColor,
          },
          { root: true },
        )
      }
    } // client_id & payload length > 0
  },

  push2Import: ({ commit, dispatch, rootState }, payload) => {
    const thisAction = 'Push Categories to Import'

    if (payload && {}.hasOwnProperty.call(payload, 'sheetData')) {
      if (rootState.customer.customers.selectedItem.client_id.length > 0 && payload.sheetData.length > 0) {
        commit(setIsBusy, true)

        const emptyItem = { id: null, vendor_id: null, description: null }
        const items2Import = []
        let item2Import = {}

        for (const currentItem of payload.sheetData) {
          item2Import = { ...emptyItem }

          item2Import.id = currentItem[state.categories.tabbedColumns.id_header]
          item2Import.vendor_id = currentItem[state.categories.tabbedColumns.id_header]
          item2Import.description = currentItem[state.categories.tabbedColumns.description_header]

          items2Import.push(item2Import)
        }

        dispatch('importData/setRows', { sheetName: state.displayAsPlural, sheetRows: items2Import.length }, { root: true })
        commit('push2Import', items2Import)
      }
    }
  },

  executeImport: ({ dispatch }) => {
    dispatch('importAll', state.categories.toImport)
  },
}

const getters = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
